import { client } from '../client';
import { IGMRegisteredMedia } from '../communication/types/IGMRegisteredMedia';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export interface RegisterMediaPayload {
  files: Array<{
    filename: string;
    mimetype: string;
    attributes?: { [x: string]: string };
  }>;
}

export const registerOneReportMedia = async (
  payload: RegisterMediaPayload,
  userRole?: string,
): Promise<IGMRegisteredMedia> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.post<IGMRegisteredMedia>(`${prefix}/media/register_upload`, payload);

  return data;
};
